export enum WidgetWorkspace {
  Customers = 'Customers/Customer/Workspace',
  Suppliers = 'Suppliers/Supplier/Workspace',
  SalesInvoices = 'Customers/Invoice/Workspace',
  SalesInvoiceLines = 'Customers/InvoiceLine/Workspace',
  SalesReceipts = 'Customers/Receipt/Workspace',
  NominalAccounts = 'Nominal/Accounts/Workspace',
  NominalTransactions = 'Nominal/NominalTransaction/Workspace',
  BankAccounts = 'Bank/Bank/Workspace',
  Products = 'Products/Product/Workspace',
  SalesOrders = 'Sales/Order/Workspace',
  SalesQuotes = 'Sales/Quote/Workspace',
  SalesOrdersAndQuotes = 'Sales/CombinedSales/Workspace',
  SalesOrderItems = 'Sales/OrderLine/Workspace',
  Tasks = 'Diary/Task/Workspace',
  PurchaseOrders = 'Purchasing/Order/Workspace',
  SalesCredits = 'Customers/Credit/Workspace',
  SalesCreditLines = 'Customers/CreditLine/Workspace',
  CustomerRefunds = 'Customers/Refund/Workspace',
  CustomerBadDebts = 'Customers/BadDebt/Workspace',
  SalesTransactions = 'Customers/Transaction/Workspace',
  ImportedAmazonOrders = 'Sales/Channel/ImportedAmazonOrder/Workspace',
  ImportedEbayOrders = 'Sales/Channel/ImportedEbayOrder/Workspace',
  ImportedShopifyOrders = 'Sales/Channel/ImportedShopifyOrder/Workspace',
  ImportedPixSellOrders = 'Sales/Channel/ImportedPixSellOrder/Workspace',
  ImportedWooCommerceOrders = 'Sales/Channel/ImportedWooCommerceOrder/Workspace',
  NominalAccrualsAndPrepayments = 'Nominal/AccrualPrepayment/Workspace',
  VatTransactions = 'VAT/Transaction/Workspace',
  PurchaseTransactions = 'Suppliers/Transaction/Workspace',
  PurchaseInvoices = 'Suppliers/Invoice/Workspace',
}
